import { useTranslation } from "react-i18next";
import { useIncorporationWizardFormCtx } from "../../hooks/IncorporationWizardFormContext";
import Layout from "../components/Layout";
import { ProgressStepItem } from "./ProgressStepItem";
import type { TFunction } from "i18next";
import { getLanguage, sendEvent } from "@/utils";
import { useEffect } from "react";

/**
 * this will always be the first step in the wizard form
 */
export default function StepProgressPanel() {
  const { currIndex, steps, data, canNext, next, setCurrIndex} = useIncorporationWizardFormCtx();
  const { t } = useTranslation();
  const language = getLanguage(); 
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const step = params.get('step');

  useEffect(() => {
    // effect para redirect a un step específico si se pasa como query param
    if(step) {
      const parsedStep = parseInt(step);
      if(isNaN(parsedStep)) {
        console.error(`Invalid step index: ${step}`);
        return;
      }
      try {
        window.history.replaceState({}, '', window.location.pathname);
        setCurrIndex(parsedStep);
      } catch (error) {
        console.error(error);
      }
    }
  }, [step, setCurrIndex]);


  const handleNext = () => {
    // redireccionar a simple signup si no esta logueado 
    // y guardar en localstorage la redirect url como en kyb
    if(!data?.currentUser) {
      const nextStepIndex = 1; // StepProgressPanel is at index 0, next step is 1
      const url = new URL(window.location.href);
      url.searchParams.set('step', nextStepIndex.toString());
      const currentLocation = url.pathname + url.search;
      localStorage.setItem('stored_location', currentLocation);
      return window.location.href = `/${language}/users/simple_signup?source=incorporation`;
    }
    sendEvent({ 
      event_name: 'Usuario inicia flujo de Incorporation Request', 
      properties: { 
        incorporation_request_id: data?.incorporationRequest?.id, 
        user_email: data.currentUser.email,
      }
    })
    next();
  };

  const stepsToShow = steps.filter((StepComponent) => !StepComponent.hideFromProgressPanel);
  
  return (
    <Layout
      title={t("progress_panel.title")}
      description={t("progress_panel.description")}
      hideBackButton
    >
      <div className="text-center">
        {stepsToShow
          .map((StepComponent, index) => (
            <ProgressStepItem
              key={index}
              index={index}
              label={
                typeof StepComponent.title === "function"
                  ? StepComponent.title(t)
                  : StepComponent.title
              }
              description={
                typeof StepComponent.description === "function"
                  ? StepComponent.description(t)
                  : StepComponent.description
              }
              status={
                data && StepComponent.isComplete?.(data) ? "completed" : "pending"
              }
              current={index === currIndex}
              hasLine={index < stepsToShow.length - 1}
              hideNumber={false}
            />
          ))}
        <button
          type="button"
          disabled={!canNext}
          className="btn btn-black w-100 w-md-50 mt-3"
          onClick={handleNext}
        >
          {t("start_wizard")}
        </button>
      </div>
    </Layout>
  );
}

/** esto es prueba no deberia ir osea no deberia ir en el builder */
StepProgressPanel.title = (t: TFunction) => t("progress_panel.progress_title");
StepProgressPanel.isComplete = () => false; // Progress panel is never "complete"
StepProgressPanel.hideFromProgressPanel = true;
